PegasusTemplate.StructureMutatorBaseMixin = Ember.Mixin.create({
  addChildren: function(element, children) {
    var container = this;
    PegasusTemplate.Helpers.scrapeAttributes(element, this);
    PegasusTemplate.Helpers.scrapeClassNames(element, this);

    children.each( function(index, childElement) {
      container.pushObject(container.childFactory(childElement));
    });
  },

  didInsertElement: function(){
    this._super();

    if ( PegasusTemplate.blockRegionInstance === this ) {
      Em.run.scheduleOnce('afterRender', this, 'notifyLoaded');
    }
  },

  notifyLoaded: function(){
    this.get('controller').send('templateLoaded');
  },

  sourceElement: '',

  mutateForOut: function(includeWrapper, cookieOnly) {
    var attributes = PegasusTemplate.Helpers.collectAttributes( this, this.get('attributeBindings') ),
      tag = this.get('tagName') || 'div',
      html;

    delete attributes.draggable;

    attributes += ' id="'+this.get('elementId')+'"';

    var children = this.map( function(child) {
      return child.mutateForOut(includeWrapper, cookieOnly);
    });

    var message;
    if ( !cookieOnly ) {
      message = children.map(function(item) {
        return item.message;
      });
    }

    var editor_cookie = children.map(function(item) {
      return item.editor_cookie;
    });

    function backgroundFinalMessage(message, color, imageURL) {
      var insideWrapperTop = [
        '<div style="background-color:',
        color,
        ';"> <!--[if gte mso 9]> <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t"> <v:fill type="tile" src="',
        imageURL,
        '" color="',
        color,
        '"/> </v:background> <![endif]--> <table height="100%" width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td valign="top" align="left" style="padding: 36px 0;',
        'background-image:url(' + imageURL + ');',
        '" background="',
        imageURL,
        '" data-background-image="',
        imageURL,
        '">'
      ].join('');

      var insideWrapperBottom = '</td></tr></table></div>';

      return insideWrapperTop + message + insideWrapperBottom;
    }

    function sanitize(text){
      var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      while (SCRIPT_REGEX.test(text)) {
        text = text.replace(SCRIPT_REGEX, "");
      }
      return text;
    }

    function assemble(elements, finalize) {
      var openingTag = [
          tag,
          attributes
        ].join(' ').replace(/^(<)?/, '<').concat('>'),
        innerHTML = elements.join(''),
        closingTag = '</' + tag + '>';

      html =
        openingTag +
        innerHTML +
        closingTag;

      if( html.length ){
        if( finalize ){
          html = sanitize( html );
        }
      } else {
        return '';
      }

      return html;
    }

    if ( cookieOnly ) {
      return {
        editor_cookie: assemble( editor_cookie, true )
      };
    }

    var assembledMessage = message ? assemble( message, false) : ''; // assume message will sanitized out back
    if ( this.get('parentView.parentView') === PegasusTemplate.canvasInstance && includeWrapper) {
      assembledMessage = backgroundFinalMessage(
        assembledMessage,
        PegasusTemplate.lookupController('toolbar').get('selectedBackgroundColor'),
        PegasusTemplate.lookupController('toolbar').get('selectedBackgroundImage')
      );
    }


    return {
      message: assembledMessage,
      editor_cookie: assemble( editor_cookie, true )
    };
  }
});
